import Bike from './Bike.js';
import ChosenBike from './ChosenBike.js';
import { useState, useEffect } from 'react';
import featureFlags from './featureFlags.json';

const { enablePreferredHubFilter: ENABLE_PREFERRED_HUB_FILTER } = featureFlags;

const ViewBikes = ({ user, setUser, sendEmail, logout }) => {
  let [locations, setLocations] = useState([]);
  function loadLocations() {
    fetch("/getAllLocations")
      .then(res => {
        let response = res;
        //console.log(response);
        return (response.json());
      })
      .then(response => {
        let final = response;
        //console.log(final);
        setLocations(final);

      })

      .catch(
        e => {
          //console.log("Error:" + e)
          alert("There was an error connecting to our server to load the bikes. Could you logout, login and try again?")
          logout()
        }
      )
  }
  useEffect(() => {
    loadLocations();
  }, []);


  let [selectedBike, setSelectedBike] = useState();
  const [pickupSlots, setPickupSlots] = useState()
  let [bikes, setBikes] = useState([]);
  useEffect(() => {
    loadBikes();
  }, []);

  function loadBikes() {
    let data = { email: 'all' };
    fetch("/getAllBikesNoPics", {
      method: "POST",
      body: JSON.stringify(data),
      headers: { "Content-Type": "application/json" }
    })
      .then(res => {
        let response = res;
        //console.log(response);
        return (response.json());
      })
      .then(response => {
        let local = response;
        //console.log(local);
        setBikes(local);
      })

      .catch(
        e => {
          //console.log("Error:" + e)
          alert("There was an error connecting to our server to load the bikes. Please logout, login and try again. Error: " + e)
          logout()
        }

      )


  }

  useEffect(() => {
    loadPickupSlots();
  }, []);

  useEffect(() => {
    loadPickupSlots();
  }, [selectedBike]);

  function loadPickupSlots() {
    // Fetch all locations, then fetch all pickup slots
    fetch("/getAllLocations")
      .then(res => {
        return res.json();
      })
      .then(res => {
        let locations = res;
        fetch("/getAllPickupSlots")
          .then(res => {
            return res.json();
          })
          .then(res => {
            let pickupSlots = res;
            let locationSlots = [];
            for (let i = 0; i < locations.length; i++) {
              locationSlots.push(locations[i]);
              locationSlots[i].pickup_slots = [];
            }
            for (let i = 0; i < locations.length; i++) {
              for (let j = 0; j < pickupSlots.length; j++) {
                if (pickupSlots[j].location_id === locations[i].id) {
                  locationSlots[i].pickup_slots.push(pickupSlots[j]);
                }
              }
            }
            setPickupSlots(locationSlots);
          })
      })
      .catch(
        e => {
          //console.log("Error fetching pickup slots:" + e)
          alert("There was an error connecting to our server to load the pickup slots. Please logout, login and try again. Error: " + e)
          logout()
        }
      )

  }

  let bikesFiltered = bikes.filter(bike => {
    //2023 -> Removed the test for males:
    //console.log('Filtering bike:', bike);
    let testSize = bike.size == user.bike_size;
    let testStatus = bike.status == "Available";
    let testBikeHub = !ENABLE_PREFERRED_HUB_FILTER || (bike.location == user.preferredHub || user.preferredHub == 0); // 0 means "I can go to any of the Hubs to pick up a bike"
    //convert user.priority to integer:
    let testPriority = (parseInt(user.priority) > 0)
    //console.log('Priority:',user.priority)
    return (testSize && testStatus && testPriority && testBikeHub)
  });

  //console.log('Bikes Filtered:',bikesFiltered);

  //useeffect to find the user's preferred hub name:
  let [userPreferredHub, setUserPreferredHub] = useState("");
  useEffect(() => {
    if (user.preferredHub) {
      let hub = locations.find(location => location.id == user.preferredHub);
      if (hub) {
        setUserPreferredHub(hub.name);
      } else {
        setUserPreferredHub("Unknown Hub");
      }
    } else {
      setUserPreferredHub("None, I can go to any of the hubs to pick up a bike.");
    }
  }, [user.preferredHub, locations]);
  return (

    user.bike_id && Object.keys(bikes).length > 0 ?
      <>
        <h3>Chosen Bike</h3>
        <div className="chosenBike">
          <ChosenBike user={user} setUser={setUser} key="chosenBike" bikes={bikes} pickupSlots={pickupSlots} sendEmail={sendEmail} />
        </div>
      </>
      : Object.keys(bikes).length > 0 ?
        Object.keys(bikesFiltered).length > 0 ?
          <div className="wrapper">

            <h3>Available Bikes in Size {user.bike_size}</h3>
            <div className="wrapper">
            {/* <p><strong>Username: </strong>{user.login_name}</p> */}
            {/* <p><strong>Preferred BikeHub:</strong> {userPreferredHub}</p> */}
              <p> See a bike you like? Is it at a location you can go to? Then click on the RESERVE button. You’ll be asked to choose a time on the designated pick-up day to come and get your bike.</p>
              <p>RESERVE button not working? Please contact each bikehub to reserve this bike.</p>
              {/* {user.gender === "Female" ?
                <p>Not seeing something you like? You can check for more options later. Also, we will email you when more bikes in your size are available. Remember to check your email often so you do not miss out.</p>
                : <><p>Not seeing something you like? You can check for more options later. </p></>
              } */}
              <p>Not seeing something you like? You can check for more options later. </p>
            </div>
            <div className="bikeCatalog wrapper">
              {bikesFiltered.map(bike => {
                let uniqueKey = "bike" + bike.id;
                return (<Bike user={user} setUser={setUser} key={uniqueKey} bike={bike} pickupSlots={pickupSlots} selectedBike={selectedBike} setSelectedBike={setSelectedBike} sendEmail={sendEmail} />);
              })
              }
            </div>
          </div> 
          : <>
            <h3>Available Bikes in Size {user.bike_size}</h3>

            <div className="centeredP wrapper">
              {/* <p><strong>Username: </strong> {user.login_name}</p> */}
              {/* <p><strong>Preferred BikeHub:</strong> {userPreferredHub}</p> */}
              <p>All the bikes in your size ({user.bike_size}) have been reserved.</p>
              <p>We will email you when more bikes in your size are available.</p>
              <p>Remember to check your email often so you do not miss out.</p>


            </div>
          </>
        : <h3>Loading bikes...</h3>

  )

}
export default ViewBikes;